import React, { useState } from "react";
import "./Mentors.css";
import AyushmanImg from "../assets/images/ayushman-img.png";
import AshishImg from "../assets/images/ashish-img.png";
import GauravImg from "../assets/images/gaurav-img.png";
import AbdulImg from "../assets/images/abdul-img.png";
import NavneetImg from "../assets/images/navneet-img.png";
import NavaneethaImg from "../assets/images/navaneetha-img.png";
import SukumarImg from "../assets/images/sukumar-img.png";
import DeivaImg from "../assets/images/deiva-img.png";
import KeivalyaImg from "../assets/images/keivalya-img.png";
import NivitkarkiImg from "../assets/images/nivitkarki-img.png";

import ApurvaImg from "../assets/images/apurvaimg.png";
import ShekharImg from "../assets/images/shekhar-img.png";
import AditImg from "../assets/images/adit-img.png";
import DhanujImg from "../assets/images/dhanuj-img.png";
import PratikImg from "../assets/images/pratik-img.png";
import MohitImg from "../assets/images/mohit-img.png";

import linkedin from "../assets/images/linkedin.png";

const MentorCard = ({ name, designation, experience, text, img, icon, linkedinusername }) => {
  return (
    <div className="mentor-block-box">
      <div className="mentor-block">
        <div className="mentor__card">
          <div className="team-member-top">
            <div className="member-img-box">
              <img src={img} className="mentor__card--image" alt={name} />
              <div className="linkedin-icon">
                <a
                  href={`https://www.linkedin.com/in/${linkedinusername}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={icon} alt="LinkedIn" />
                </a>
              </div>            
            </div>
            <div className="member-text-content">
              <p className="mentor__card--name">{name}</p>
              {designation && <p className="mentor__card--designation">{designation}</p>}
              <p className="mentor__card--desc">{text}</p>
            </div>
          </div>
          <div>
            {experience && <p className="mentor__card--experience">Work Experience: <b>{experience}</b></p>}
          </div>
        </div>
      </div>
    </div>
  );
};

const Mentors = () => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="mentor__container" id="mentor-id">
      <div className="mentor">
        <div className="mentor-content-bar">
          <div className="meet-title-block">
            <div className="meet-your-title">
              Meet <span>Our Mentors</span>
            </div>
            <p>Your success, accelerated. Stop guessing and start growing with one-on one guidance from proven leaders who are dedicated to your success.</p>
          </div>
          
          <div className="mentor-right">
            <div className="mentor__card-container">
              <div className="team-member-box team-member01">
                <MentorCard
                  name={"Ayushman"}
                  designation={"Junior Research Fellow"}
                  experience={"2+ Year"}
                  text={"Junior Research Fellow at National Institute of Technology, Trichy"}
                  img={AyushmanImg}
                  icon={linkedin}
                  linkedinusername={`ayushman-jena-320b52201`}
                /> 
                <MentorCard
                  name={"Ashish"}
                  designation={"Design Lead"}
                  experience={"5+ Year"}
                  text={"Design Lead @Addverb | Ex- Orangewood Labs (Y Combinator W18)"}
                  img={AshishImg}
                  icon={linkedin}
                  linkedinusername={`ashish-chauhan-880331156`}
                />
                <MentorCard
                  name={"Apurva"}
                  designation={"Embedded Developer"}
                  experience={"3+ Year"}
                  text={"Embedded Developer MicroPython, CircuitPython || C, C+ Self employed @ Kumar International"}
                  img={ApurvaImg}
                  icon={linkedin}
                  linkedinusername={`apurva-nene-31815a159`}
                />
                <MentorCard
                  name={"Shekhar"}
                  designation={"Electronics Engineer"}
                  experience={"7+ Year"}
                  text={"Electronics Lead Engineer"}
                  img={ShekharImg}
                  icon={linkedin}
                  linkedinusername={`shekhar-nandanwar-4a5729152`}
                />                

                <MentorCard
                  name={"Gaurav"}
                  designation={"Design Lead"}
                  experience={"8+ Year"}
                  text={"Design Lead @Pricon | CAD • CAM • CAE Trainer | Freelance Product Designer"}
                  img={GauravImg}
                  icon={linkedin}
                  linkedinusername={`gaurav-kumar-jangra`}
                />
                <MentorCard
                  name={"Navneet"}
                  designation={"AI Developer"}
                  experience={"5+ Year"}
                  text={"Automation Engineer | AI Developer | Python | Robotics | Embedded Systems"}
                  img={NavneetImg}
                  icon={linkedin}
                  linkedinusername={`navneet-tiwari1`}
                />

                                                                                             
              </div>    
            </div>

            {showAll && (
              <div className="mentor__card-container less__card-container">
                <div className="team-member-box">
                <MentorCard
                  name={"Adit"}
                  designation={"ROS Developer "}
                  experience={"4+ Year"}
                  text={"ROS Developer at Larsen & Toubro Technological Services"}
                  img={AditImg}
                  icon={linkedin}
                  linkedinusername={`adit-sule`}
                />
                <MentorCard
                  name={"Dhanuj"}
                  designation={"Hardware Engineer"}
                  experience={"3+ Year"}
                  text={"Graphics Hardware Engineer at Intel"}
                  img={DhanujImg}
                  icon={linkedin}
                  linkedinusername={`dhanujkumarsharma`}
                /> 
                <MentorCard
                  name={"Pratik"}
                  designation={"Design Lead"}
                  experience={"4+ Year"}
                  text={"Mechanical Design @ Honeywell"}
                  img={PratikImg}
                  icon={linkedin}
                  linkedinusername={`pratikseetharam`}
                /> 
                  <MentorCard
                    name={"Nivit"}
                    designation={"Project Assistant"}
                    experience={"3+ Year"}
                    text={"Project Assistant at Indian Institute of Technology, Delhi"}
                    img={NivitkarkiImg}
                    icon={linkedin}
                    linkedinusername={`nivit-karki-a5929b1b4`}
                  />                 
                  <MentorCard
                    name={"Mohit"}
                    designation={"Developer"}
                    experience={"4+ Year"}
                    text={"Course Developer at Mcmaster University "}
                    img={MohitImg}
                    icon={linkedin}
                    linkedinusername={`hellomohit`}
                  />
                </div>
              </div>
            )}
            <div className="see-more-btns">
            <div 
              className={`mentor-show-more ${showAll ? 'Less-more' : ''}`}
              onClick={() => setShowAll(!showAll)}
              style={{ cursor: 'pointer' }}
            >
              {showAll ? 'See Less' : 'See More!'}
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mentors;